var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg-icon',{staticStyle:{"margin-top":"4px"},attrs:{"name":_vm.$auth.user && _vm.$auth.user.premium ? 'logo-black-premium' : 'logo-black',"width":_vm.width || 128}})}
var staticRenderFns = []

export { render, staticRenderFns }